<template>
  <div class="activity">
    <i class="back" @click="back"></i>
    <img class="img" v-for="(image, index) in images" :key="index" :src="image">
    <div class="btn-static"></div>
    <img class="btn" :src="btnImage" v-on:click="clickToBuy">
  </div>
</template>

<script>
import utils from '@/assets/js/utils'
export default {
  data() {
    return {
      images: [
        'https://appd.knowbox.cn/ss/teacher/point-reading/01.png',
        'https://appd.knowbox.cn/ss/teacher/point-reading/02.png',
        'https://appd.knowbox.cn/ss/teacher/point-reading/03.png',
        'https://appd.knowbox.cn/ss/teacher/point-reading/04.png',
      ],
      btnImage: 'https://appd.knowbox.cn/ss/teacher/point-reading/05.png',
      token: "",
      source: "",
      version: "",
      activityId: "",
    };
  },
  methods: {
    clickToBuy: function() {
      utils.sendLog({
        token: this.token,
        version: this.version,
        source: this.source,
        extensionJson: {
          event: 3,
          adId: this.activityId
        }
      }, 'hzxx691')
      this.$router.push({path: "/parentActive/dot-read-select-book?token=" + this.token + "&source=" + this.source + "&version=" + this.version})
    },
    back: function() {
      location.href = "hybird://method/exit";
    },
  },
  mounted() {
    this.token = utils.getQueryString("token")
    this.source = utils.getQueryString('source')
    this.version = utils.getQueryString('version')
    this.activityId = utils.getQueryString("activityId")
    let self = this;
    utils.sendLog({
      token: this.token,
      version: this.version,
      source: this.source,
      extensionJson: {
        event: 3,
        adId: this.activityId
      }
    }, 'hzxx692')
  },
}
</script>

<style lang="scss" scoped>
.activity {
  background: #fff;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  .back {
    position: fixed;
    left: 0.35rem;
    top: 0.38rem;
    width: 0.6rem;
    height: 0.6rem;
    background: url("../../../assets/images/common/back.png") 0 0 no-repeat;
    background-size: 100%;
  }
  .img {
    width: 100%;
  }
  .btn-static{
    width: 100%;
    height: 1.57rem;
  }
  .btn {
    position: fixed;
    width: 100%;
    height: 1.57rem;
    bottom: 0;
  }
  /*iPhone X XS 2436x1125px at 458ppi */
  @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
    .back {
      top: calc(0.31rem + constant(safe-area-inset-top));
      top: calc(0.31rem + env(safe-area-inset-top));
    }
  }

  /*iPhone XR 1792x828px at 326ppi */
  @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
    .back {
      top: calc(0.31rem + constant(safe-area-inset-top));
      top: calc(0.31rem + env(safe-area-inset-top));
    }
  }

  /* iPhone XS Max 2688x1242px at 458ppi */
  @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
    .back {
      top: calc(0.31rem + constant(safe-area-inset-top));
      top: calc(0.31rem + env(safe-area-inset-top));
    }
  }
}
</style>